/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/currency';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "model": {
            "nested": {
              "TaxAdjustment": {
                "fields": {
                  "type": {
                    "type": "squareup.solidshop.model.TaxAdjustment.Type",
                    "id": 1,
                    "rule": "optional"
                  },
                  "label": {
                    "type": "squareup.solidshop.model.TaxAdjustment.Label",
                    "id": 2,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": "squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "rate": {
                    "type": "int32",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "TYPE_DO_NOT_USE": 0,
                      "ADDITIONAL_TAX": 1,
                      "INCLUDED_TAX": 2
                    }
                  },
                  "Label": {
                    "values": {
                      "LABEL_DO_NOT_USE": 0,
                      "US_TAX": 1,
                      "CA_GST": 1001,
                      "CA_HST": 1002,
                      "CA_PST": 1003,
                      "CA_QST": 1004,
                      "AU_GST": 2001,
                      "GB_VAT": 3001,
                      "JP_TAX": 4001,
                      "ES_VAT": 5001,
                      "FR_VAT": 6001
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE TaxAdjustment @ squareup/solidshop/model/tax_adjustment.proto at 7:1
 */
export const TaxAdjustment = $root.lookupType('squareup.solidshop.model.TaxAdjustment');
fixType(TaxAdjustment);
Builder.createAndAttachToType(TaxAdjustment);
/**
 * SOURCE Type @ squareup/solidshop/model/tax_adjustment.proto at 8:3
 */
TaxAdjustment.Type = $root.lookupEnum('squareup.solidshop.model.TaxAdjustment.Type').values;
/**
 * SOURCE Label @ squareup/solidshop/model/tax_adjustment.proto at 14:3
 */
TaxAdjustment.Label = $root.lookupEnum('squareup.solidshop.model.TaxAdjustment.Label').values;
